export default "__VITE_ASSET__BttORehK__"